{
  "title": "กล่องข้อความ",
  "totalBadge": "{{count}} รายการ",
  "viewAll": "ดูทั้งหมด",
  "loading": "กำลังโหลด…",
  "emptySection": "ดำเนินการครบแล้ว",
  "loadError": "ไม่สามารถโหลดส่วนนี้ได้"
}
